import { useEffect, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { useDispatch } from "react-redux";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  HashRouter,
  BrowserRouter,
  useNavigate,
} from "react-router-dom";

import { AppRouter } from "./routers/AppRouter";



function App() {

  return (
    <BrowserRouter basename="/">
      <AppRouter></AppRouter>
    </BrowserRouter>
  );
}

export default App;
